import { defineStyle } from '@chakra-ui/react';

import colors from '@/styles/themes/brand/colors';
import FontSizes from '@/styles/themes/brand/fontSizes';
import FontWeights from '@/styles/themes/brand/fontWeights';

const theme = defineStyle({
  root: {
    flex: 1,
    placeItems: 'flex-start',
  },
  vendorRatingContainer: {
    flexDirection: { base: 'column', md: 'row', lg: 'row' },
    border: { md: '1px solid #D6D6D6' },
    borderRadius: { md: '60px' },
    // padding: { md: '10px' },
  },
  ratingDivider: {
    width: '1px',
    // height: '50px',
    background: '#1A255033',
    border: 'none',
    // marginTop: '7px',
  },
  divider: {
    my: '10px',
  },
  headContainer: {
    alignItems: 'flex-start',
    gap: '15px',
  },
  socialItemBox: {
    gap: '15px',
  },
  socialItemIconWrapper: {
    borderRadius: '100%',
    background: colors.secondary,
    padding: '10px',
  },
  socialItemIcon: {
    color: 'white',
    height: '22px',
    width: '22px',
  },
  socialItemTitle: {
    fontWeight: FontWeights.light,
    fontSize: FontSizes.normal,
  },
  socialItemSubtitle: {
    fontWeight: FontWeights.semibold,
    fontSize: FontSizes.normal,
  },
  infoBoxWrapper: {
    flex: 1,
    alignItems: 'flex-start',
    gap: '15px',
  },
  infoBoxTitle: {
    fontWeight: FontWeights.light,
    fontSize: FontSizes.normal,
  },
  infoBoxSub: {
    fontWeight: FontWeights.semibold,
    fontSize: FontSizes.normal,
    wordBreak: 'break-word',
  },
  textTitle: {
    fontWeight: FontWeights.semibold,
    fontSize: FontSizes.normal,
  },
  servicesBox: {
    w: '100%',
  },
  serviceItem: {
    width: '100%',
    py: '10px',
    fontWeight: FontWeights.medium,
    fontSize: FontSizes.small,
    '&:nth-child(odd)': {
      background: 'whitesmoke',
    },
    '&:nth-child(even)': {
      background: 'white',
    },
  },
  reviewBox: {
    gap: '10px',
    w: '100%',
    borderBottom: '1px solid rgba(232, 232, 232, 1)',
  },
  reviewRow: {
    w: '100%',
    py: '15px',
    placeItems: 'flex-start',
    borderBottom: `1px solid ${colors.border}`,
    '&:last-child': {
      borderBottom: 'none',
    },
  },

  reviewTitleBox: {
    placeItems: 'flex-start',
    gap: '10px',
  },
  reviewTitle: {
    fontWeight: FontWeights.medium,
    fontSize: FontSizes.normal,
  },
  starWrapper: {
    gap: '5px',
    alignItems: 'center',
  },
  starIcon: {
    paddingBottom: '5px',
  },
  reviewSubtitle: {
    fontWeight: FontWeights.normal,
    fontSize: FontSizes.normal,
    color: '#000',
  },
  noCustomerReview: {
    color: '#00000080',
  },
  reviewDate: {
    fontWeight: FontWeights.normal,
    fontSize: FontSizes.small,
    textDecoration: 'underline',
    textAlign: 'right',
  },
  viewMoreBtn: {
    alignSelf: 'center',
    textTransform: 'none',
    span: {
      fontWeight: FontWeights.bold,
    },
    mt: '24px',
  },
  accordionIcon: {
    fontSize: 'large',
  },
  reviewTextLabel: {
    fontSize: FontSizes.large,
    fontWeight: FontWeights.semibold,
  },
  reviewBorder: { margin: '20px 0px 5px 0px', color: 'rgba(232, 232, 232, 1)' },
  emptyDetails: {
    alignItems: 'center',
    mt: '10px',
    width: '100%',
    gap: '20px',
  },
  detailsContainer: { width: '100%', gap: '20px' },
  vendorResponseContainer: {
    paddingLeft: '28px',
    gap: '12px',
    flexDir: 'column',
    paddingTop: '5px',
  },
  responseLabel: {
    fontSize: FontSizes.normal,
    fontWeight: FontWeights.semibold,
  },
  responseDescription: {
    fontSize: FontSizes.normal,
    fontWeight: FontWeights.normal,
  },
});

export default theme;
